import {FailResponse, InternalServerError} from '../models/response-model';
import {isObject} from '../../lib/helpers';

function isFailResponse(payload: any): payload is FailResponse {
  if (!isObject(payload))
    return false;
  let tmp = payload as FailResponse;
  if (tmp.Status !== 'Failure')
    return false;
  if (tmp.Errors !== null && !Array.isArray(tmp.Errors))
    return false;
  return true;
}

function isInternalServerError(payload: any): payload is InternalServerError {
  if (!isObject(payload))
    return false;
  let tmp = payload as InternalServerError;
  if (tmp.Status !== 'InternalServerError')
    return false;
  if (tmp.Timestamp !== 'string')
    return false;
  if (tmp.StackTrace !== null && !Array.isArray(tmp.StackTrace))
    return false;
  return true;
}

class ResponseUtils {
  readonly isFailResponse = isFailResponse;
  readonly isInternalServerError = isInternalServerError;
}

export const responseUtils = new ResponseUtils();
